import { MAX_DAY_RANGE } from "./props";
import { useIsFeatureEnabled } from "./useIsFeatureEnabled";

export function useMaxDayRange() {
  return useIsFeatureEnabled(MAX_DAY_RANGE);
}
